module.exports = "/images/icon-heart-empty.svg?4fe95387cd1fec3989c9b78358553581";